import {Injectable, Injector} from "@angular/core";
import {EntityData, EntityModel, field} from "@fedelta-pos/data-client";
import {IntegratedPaymentProvider} from "./payment";

export class OrderPaymentDetailsData extends EntityData<OrderPaymentDetailsData> {
    @field provider: IntegratedPaymentProvider;
    @field cardBrand: string;
    @field cardCountry: string;
    @field cardLast4: string;
    @field paymentIntentId: string;
    @field platformPublicKey: string;
    @field platformLiveMode: boolean;
    @field paymentMethods: string;
}

@Injectable()
export class OrderPaymentDetailsEntityModel extends EntityModel<OrderPaymentDetailsData> {
    constructor(injector: Injector) {
        console.log("--- OrderPaymentDetailsEntityModel");

        super(injector, OrderPaymentDetailsData);
    }

    getResourceName(): string {
        return "web-order-payment-details";
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/order-payment-details-entity.model.ts